var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCalendarFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 7h18v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7Zm5-7a1 1 0 0 1 1 1v1h6V1a1 1 0 1 1 2 0v1h2c1 0 2 1 2 2v1H0V4c0-1 1-2 2-2h2V1a1 1 0 0 1 1-1Z"
})));
export default SvgIconCalendarFilled;